import React from "react";
import { styled } from "@mui/material/styles";
import Tabs, { TabsProps } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

interface StyledTabProps {
  label: string;
}

export const StyledTabs = styled((props: TabsProps) => (
  <Tabs {...props} variant="scrollable" scrollButtons="auto" />
))({
  borderBottom: "1px solid #e8e8e8"
});

export const StyledTab = styled((props: StyledTabProps) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4)
  })
);
